(ns minorodata.connections.sources.list
  (:require [minorodata.connections.sources.sql-server :as sources.sql-server]
            [minorodata.connections.sources.appsflyer :as sources.appsflyer]
            [minorodata.connections.sources.asana :as sources.asana]
            [minorodata.connections.sources.big-query :as sources.big-query]
            [minorodata.connections.sources.e-conomic :as sources.e-conomic]
            [minorodata.connections.sources.elasticsearch :as sources.elasticsearch]
            [minorodata.connections.sources.everhour :as sources.everhour]
            [minorodata.connections.sources.famly :as sources.famly]
            [minorodata.connections.sources.google-sheets :as sources.google-sheets]
            [minorodata.connections.sources.google-sheets-oauth :as sources.google-sheets-oauth]
            [minorodata.connections.sources.google-analytics :as sources.google-analytics]
            [minorodata.connections.sources.google-search-console :as sources.google-search-console]
            [minorodata.connections.sources.hgem :as sources.hgem]
            [minorodata.connections.sources.mysql :as sources.mysql]
            [minorodata.connections.sources.mysql-binlog :as sources.mysql-binlog]
            [minorodata.connections.sources.postgresql :as sources.postgresql]
            [minorodata.connections.sources.hubspot :as sources.hubspot]
            [minorodata.connections.sources.s3-file-ingest :as sources.s3-file-ingest]
            [minorodata.connections.sources.supportpal :as sources.supportpal]
            [minorodata.connections.sources.twilio :as sources.twilio]
            [minorodata.connections.sources.facebook-adinsights :as sources.facebook-adinsights]
            [minorodata.connections.sources.facebook-adinsights-oauth :as sources.facebook-adinsights-oauth]
            [minorodata.connections.sources.linkedin-marketing :as sources.linkedin-marketing]
            [minorodata.connections.sources.xero :as sources.xero]
            [minorodata.connections.sources.search-ads-360 :as sources.search-ads-360]
            [minorodata.connections.sources.forex-rates :as sources.forex-rates]
            [minorodata.connections.sources.stripe :as sources.stripe]
            [minorodata.connections.sources.outreach :as sources.outreach]
            [minorodata.connections.sources.amplitude :as sources.amplitude]
            [minorodata.connections.sources.awin :as sources.awin]
            [minorodata.connections.sources.webgains :as sources.webgains]
            [minorodata.connections.sources.mongodb :as sources.mongodb]
            [minorodata.connections.sources.polaris :as sources.polaris]
            [minorodata.connections.sources.optimove :as sources.optimove]
            [minorodata.connections.sources.shopify :as sources.shopify]
            [minorodata.connections.sources.partnerize :as sources.partnerize]
            [minorodata.connections.sources.rakuten :as sources.rakuten]
            [minorodata.connections.sources.mailchimp :as sources.mailchimp]
            [minorodata.connections.sources.affiliate :as sources.affiliate]
            [minorodata.connections.sources.affiliate-gateway :as sources.affiliate-gateway]
            [minorodata.connections.sources.quickbooks :as sources.quickbooks]
            [minorodata.connections.sources.salesforce :as sources.salesforce]
            [minorodata.connections.sources.discord    :as sources.discord]
            [minorodata.connections.sources.mysql-aurora :as sources.mysql-aurora]
            [minorodata.connections.sources.tiktok     :as sources.tiktok]
            [minorodata.connections.sources.bing-ads :as sources.bing-ads]
            [minorodata.connections.sources.netsuite :as sources.netsuite]))


(def all
  [sources.big-query/source
   sources.sql-server/source
   sources.forex-rates/source
   sources.stripe/source
   sources.mysql/source
   sources.mysql-binlog/source
   sources.xero/source
   sources.search-ads-360/source
   sources.hubspot/source
   sources.google-analytics/source
   sources.google-search-console/source
   sources.google-sheets/source
   sources.google-sheets-oauth/source
   sources.s3-file-ingest/source
   sources.supportpal/source
   sources.postgresql/source
   sources.facebook-adinsights/source
   sources.facebook-adinsights-oauth/source
   sources.linkedin-marketing/source
   sources.outreach/source
   sources.amplitude/source
   sources.elasticsearch/source
   sources.awin/source
   sources.polaris/source
   sources.e-conomic/source
   sources.hgem/source
   sources.appsflyer/source
   sources.mongodb/source
   sources.everhour/source
   sources.webgains/source
   sources.twilio/source
   sources.optimove/source
   sources.famly/source
   sources.shopify/source
   sources.partnerize/source
   sources.rakuten/source
   sources.asana/source
   sources.mailchimp/source
   sources.affiliate/source
   sources.affiliate-gateway/source
   sources.quickbooks/source
   sources.salesforce/source
   sources.discord/source
   sources.mysql-aurora/source
   sources.tiktok/source
   sources.bing-ads/source
   sources.netsuite/source])
